import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Logo from '../media/logo.png';
import Banner from '../media/banner.png';
import CustomDropdown from '../components/ui/CustomeDropdown';
import { fetchMarket } from '../api';
import { sortBy } from 'lodash';

const HeaderStyle = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 64px;
  z-index: 0;
  padding: 0rem 2rem;
`;
const ContainerStyle = styled.div`
  display:flex;
  width: 100%;
  height: 100%;
  padding: 3rem 1rem;
  gap:10px;
`;
const LogoStyle = styled.img`
  height:30px;
`;
const LeftSideContaint = styled.div`
  width:70%;
  background:#4472c4;
  padding:4rem 1rem;
  @media only screen
  and (min-device-width: 768px)
  and (max-device-width: 1024px)
  and (-webkit-min-device-pixel-ratio: 1)
  and (orientation: portrait){
   height:90vh;
  }
`;
const LeftSideSection = styled.div`
  background:#ffffff;
  align=item:center;
  padding:0px 0px 20px 0px;
  @media only screen
  and (min-device-width: 768px)
  and (max-device-width: 1024px)
  and (-webkit-min-device-pixel-ratio: 1)
  and (orientation: portrait){
  padding: 200px 10px;
  }
`;
const LeftSideHeader = styled.h1`
  color:#000000;
  width:43%;
  margin:0px auto;
  padding:20px 0px;
  @media only screen
  and (min-device-width: 768px)
  and (max-device-width: 1024px)
  and (-webkit-min-device-pixel-ratio: 1)
  and (orientation: portrait){
    width:50%;
  }
`;
const RightSideContaint = styled.div`
  width:30%;
  background:#ffdb00;
  padding:0px; 
`;
const Label = styled.label`
font-size:14px;
`
const BannerImg=styled.img`
width:auto;
@media only screen
  and (min-device-width: 768px)
  and (max-device-width: 1024px)
  and (-webkit-min-device-pixel-ratio: 1)
  and (orientation: portrait){
  width: 100%; 
}
`;
const SelectWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 255px; 
  @media only screen
  and (min-device-width: 768px)
  and (max-device-width: 1024px)
  and (-webkit-min-device-pixel-ratio: 1)
  and (orientation: portrait){
    width: 185px; 
    margin-left: -10px;
  }
`;
const MarketDropdownDiv = styled.div`
margin-top: 150px;
    background: #fff094;
    padding: 0px 20px;`;

const RightArrow = styled.svg`
width:25px;
height:25px;
margin-right:10px;
float:right;
`;
const RightSideHeader = styled.h3`
margin-top:30px;
padding:0px 20px; 
@media only screen
  and (min-device-width: 768px)
  and (max-device-width: 1024px)
  and (-webkit-min-device-pixel-ratio: 1)
  and (orientation: portrait){
  padding: 0px 0px 0px 20px;
}
`;
const Link = styled.a`
cursor:pointer;
`;

const StartPageView = () => {
  const history = useNavigate();
  const [disable, setdisable] = useState(true);
  const [selectedMarketLang, setSelectedMarketLang]=useState()
  const [marketList, setMarketList]=useState([])
  useEffect(() => {
    getMarketList();
  }, []);

  const getMarketList = async () => {
    try {
      const response = await fetchMarket()
      if (response.status = 200) {
        const sortedMarketList = sortBy(response.data, 'displayLabel');
        setMarketList(sortedMarketList)

      }
    } catch (error) {
      console.error('Error sending data:', error.message);
    }

  };
  const handleMarketChange = (countryCode, languageCode) => {
    const selectedMarketLang = {
      countryCode: countryCode,
      languageCode: languageCode
    }
    setSelectedMarketLang(selectedMarketLang)
    setdisable(false);
    //localStorage.setItem('selectedMarketLang', JSON.stringify(selectedMarketLang));

  }
  const goToiFoodPPSIView = () => {
    //const selectedMarket = JSON.parse(localStorage.getItem('selectedMarketLang'));
    localStorage.setItem('selectedMarketLang', JSON.stringify(selectedMarketLang));
    const url = `/dppsi/${selectedMarketLang.countryCode}/${selectedMarketLang.languageCode}/menu`;
    history(url);
  }
  useEffect(() => {
    //Initialize state variables from local storage
    const selectedMarket = JSON.parse(localStorage.getItem('selectedMarketLang'));
    if (selectedMarket) {
      const url = `/dppsi/${selectedMarket.countryCode}/${selectedMarket.languageCode}/menu`;
      history(url);
    }
  }, []);
  return (
    <>
      <HeaderStyle><LogoStyle src={Logo} alt="Logo" /></HeaderStyle>
      <ContainerStyle>
        <LeftSideContaint>
          <LeftSideSection>
            <LeftSideHeader>From selling an icon to serving an icon</LeftSideHeader>
            <div style={{ width: "100%", textAlign: "center" }}><BannerImg src={Banner} alt="Banner" /></div>
          </LeftSideSection>
        </LeftSideContaint>
        <RightSideContaint>
          <MarketDropdownDiv>
            <Label style={{fontWeight:"600"}}>Market : </Label>
            <SelectWrapper>
              <CustomDropdown onChange={handleMarketChange} item={marketList} />
            </SelectWrapper>
          </MarketDropdownDiv>
          <Link onClick={goToiFoodPPSIView} style={{ pointerEvents: disable ? "none" : "auto", color: disable ? "gray" : "#000" }}>  <RightSideHeader >Go to iFoodPPSI
            <RightArrow xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z" /></RightArrow>
          </RightSideHeader></Link>
        </RightSideContaint>
      </ContainerStyle>
    </>
  )
}

export default StartPageView;
